export default __webpack_public_path__ + "static/media/CustomLabel.0fdbebbc.svg";